'use strict';

var _regeneratorRuntime = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var net = require('net');

var os = require('os');

var secp256k1 = require('secp256k1');

var _require = require('events');

var EventEmitter = _require.EventEmitter;

var ms = require('ms');

var Buffer = require('safe-buffer').Buffer;

var createDebugLogger = require('debug');

var LRUCache = require('lru-cache');

var pVersion = require('../../package.json').version;

var _require2 = require('../util');

var pk2id = _require2.pk2id,
    createDeferred = _require2.createDeferred;

var Peer = require('./peer');

var debug = createDebugLogger('devp2p:rlpx');

var RLPx =
/*#__PURE__*/
function (_EventEmitter) {
  _inherits(RLPx, _EventEmitter);

  function RLPx(privateKey, options) {
    var _this2;

    _classCallCheck(this, RLPx);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(RLPx).call(this));
    _this2._privateKey = Buffer.from(privateKey);
    _this2._id = pk2id(secp256k1.publicKeyCreate(_this2._privateKey, false)); // options

    _this2._timeout = options.timeout || ms('10s');
    _this2._maxPeers = options.maxPeers || 10;
    _this2._clientId = Buffer.from(options.clientId || "ethereumjs-devp2p/v".concat(pVersion, "/").concat(os.platform(), "-").concat(os.arch(), "/nodejs"));
    _this2._remoteClientIdFilter = options.remoteClientIdFilter;
    _this2._capabilities = options.capabilities;
    _this2._listenPort = options.listenPort; // DPT

    _this2._dpt = options.dpt || null;

    if (_this2._dpt !== null) {
      _this2._dpt.on('peer:new', function (peer) {
        if (!peer.tcpPort) {
          _this2._dpt.banPeer(peer, ms('5m'));

          debug("banning peer with missing tcp port: ".concat(peer.address));
          return;
        }

        if (_this2._peersLRU.has(peer.id.toString('hex'))) return;

        _this2._peersLRU.set(peer.id.toString('hex'), true);

        if (_this2._getOpenSlots() > 0) return _this2._connectToPeer(peer);

        _this2._peersQueue.push({
          peer: peer,
          ts: 0
        }); // save to queue

      });

      _this2._dpt.on('peer:removed', function (peer) {
        // remove from queue
        _this2._peersQueue = _this2._peersQueue.filter(function (item) {
          return !item.peer.id.equals(peer.id);
        });
      });
    } // internal


    _this2._server = net.createServer();

    _this2._server.once('listening', function () {
      return _this2.emit('listening');
    });

    _this2._server.once('close', function () {
      return _this2.emit('close');
    });

    _this2._server.on('error', function (err) {
      return _this2.emit('error', err);
    });

    _this2._server.on('connection', function (socket) {
      return _this2._onConnect(socket, null);
    });

    _this2._peers = new Map();
    _this2._peersQueue = [];
    _this2._peersLRU = new LRUCache({
      max: 25000
    });
    _this2._refillIntervalId = setInterval(function () {
      return _this2._refillConnections();
    }, ms('10s'));
    return _this2;
  }

  _createClass(RLPx, [{
    key: "listen",
    value: function listen() {
      var _this$_server;

      this._isAliveCheck();

      debug('call .listen');

      (_this$_server = this._server).listen.apply(_this$_server, arguments);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var _this$_server2;

      this._isAliveCheck();

      debug('call .destroy');
      clearInterval(this._refillIntervalId);

      (_this$_server2 = this._server).close.apply(_this$_server2, arguments);

      this._server = null;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this._peers.keys()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var peerKey = _step.value;
          this.disconnect(Buffer.from(peerKey, 'hex'));
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }, {
    key: "connect",
    value: function connect(peer) {
      var _this = this;

      return (0, _asyncToGenerator3.default)(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var peerKey, deferred, socket;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this._isAliveCheck();

                if (Buffer.isBuffer(peer.id)) {
                  _context.next = 3;
                  break;
                }

                throw new TypeError('Expected peer.id as Buffer');

              case 3:
                peerKey = peer.id.toString('hex');

                if (!_this._peers.has(peerKey)) {
                  _context.next = 6;
                  break;
                }

                throw new Error('Already connected');

              case 6:
                if (!(_this._getOpenSlots() === 0)) {
                  _context.next = 8;
                  break;
                }

                throw new Error('Too much peers already connected');

              case 8:
                debug("connect to ".concat(peer.address, ":").concat(peer.port, " (id: ").concat(peerKey, ")"));
                deferred = createDeferred();
                socket = new net.Socket();

                _this._peers.set(peerKey, socket);

                socket.once('close', function () {
                  _this._peers.delete(peerKey);

                  _this._refillConnections();
                });
                socket.once('error', deferred.reject);
                socket.setTimeout(_this._timeout, function () {
                  return deferred.reject(new Error('Connection timeout'));
                });
                socket.connect(peer.port, peer.address, deferred.resolve);
                _context.next = 18;
                return deferred.promise;

              case 18:
                _this._onConnect(socket, peer.id);

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }))();
    }
  }, {
    key: "getPeers",
    value: function getPeers() {
      return Array.from(this._peers.values()).filter(function (item) {
        return item instanceof Peer;
      });
    }
  }, {
    key: "disconnect",
    value: function disconnect(id) {
      var peer = this._peers.get(id.toString('hex'));

      if (peer instanceof Peer) peer.disconnect(Peer.DISCONNECT_REASONS.CLIENT_QUITTING);
    }
  }, {
    key: "_isAlive",
    value: function _isAlive() {
      return this._server !== null;
    }
  }, {
    key: "_isAliveCheck",
    value: function _isAliveCheck() {
      if (!this._isAlive()) throw new Error('Server already destroyed');
    }
  }, {
    key: "_getOpenSlots",
    value: function _getOpenSlots() {
      return Math.max(this._maxPeers - this._peers.size, 0);
    }
  }, {
    key: "_connectToPeer",
    value: function _connectToPeer(peer) {
      var _this3 = this;

      var opts = {
        id: peer.id,
        address: peer.address,
        port: peer.tcpPort
      };
      this.connect(opts).catch(function (err) {
        if (_this3._dpt === null) return;

        if (err.code === 'ECONNRESET' || err.toString().includes('Connection timeout')) {
          _this3._dpt.banPeer(opts, ms('5m'));
        }
      });
    }
  }, {
    key: "_onConnect",
    value: function _onConnect(socket, peerId) {
      var _this4 = this;

      debug("connected to ".concat(socket.remoteAddress, ":").concat(socket.remotePort, ", handshake waiting.."));
      var peer = new Peer({
        socket: socket,
        remoteId: peerId,
        privateKey: this._privateKey,
        id: this._id,
        timeout: this._timeout,
        clientId: this._clientId,
        remoteClientIdFilter: this._remoteClientIdFilter,
        capabilities: this._capabilities,
        port: this._listenPort
      });
      peer.on('error', function (err) {
        return _this4.emit('peer:error', peer, err);
      }); // handle incoming connection

      if (peerId === null && this._getOpenSlots() === 0) {
        peer.once('connect', function () {
          return peer.disconnect(Peer.DISCONNECT_REASONS.TOO_MANY_PEERS);
        });
        socket.once('error', function () {});
        return;
      }

      peer.once('connect', function () {
        var msg = "handshake with ".concat(socket.remoteAddress, ":").concat(socket.remotePort, " was successful");

        if (peer._eciesSession._gotEIP8Auth === true) {
          msg += " (peer eip8 auth)";
        }

        if (peer._eciesSession._gotEIP8Ack === true) {
          msg += " (peer eip8 ack)";
        }

        debug(msg);

        if (peer.getId().equals(_this4._id)) {
          return peer.disconnect(Peer.DISCONNECT_REASONS.SAME_IDENTITY);
        }

        var peerKey = peer.getId().toString('hex');

        var item = _this4._peers.get(peerKey);

        if (item && item instanceof Peer) {
          return peer.disconnect(Peer.DISCONNECT_REASONS.ALREADY_CONNECTED);
        }

        _this4._peers.set(peerKey, peer);

        _this4.emit('peer:added', peer);
      });
      peer.once('close', function (reason, disconnectWe) {
        if (disconnectWe) {
          debug("disconnect from ".concat(socket.remoteAddress, ":").concat(socket.remotePort, ", reason: ").concat(String(reason)));
        } else {
          debug("".concat(socket.remoteAddress, ":").concat(socket.remotePort, " disconnect, reason: ").concat(String(reason)));
        }

        if (!disconnectWe && reason === Peer.DISCONNECT_REASONS.TOO_MANY_PEERS) {
          // hack
          _this4._peersQueue.push({
            peer: {
              id: peer.getId(),
              address: peer._socket.remoteAddress,
              tcpPort: peer._socket.remotePort
            },
            ts: Date.now() + ms('5m')
          });
        }

        var peerKey = peer.getId().toString('hex');

        _this4._peers.delete(peerKey);

        _this4.emit('peer:removed', peer, reason, disconnectWe);
      });
    }
  }, {
    key: "_refillConnections",
    value: function _refillConnections() {
      var _this5 = this;

      if (!this._isAlive()) return;
      debug("refill connections.. queue size: ".concat(this._peersQueue.length, ", open slots: ").concat(this._getOpenSlots()));
      this._peersQueue = this._peersQueue.filter(function (item) {
        if (_this5._getOpenSlots() === 0) return true;
        if (item.ts > Date.now()) return true;

        _this5._connectToPeer(item.peer);

        return false;
      });
    }
  }]);

  return RLPx;
}(EventEmitter);

RLPx.DISCONNECT_REASONS = Peer.DISCONNECT_REASONS;
module.exports = RLPx;